import React, { useState } from 'react';
import { Button, Box, BoxProps } from '@chakra-ui/react';

import {
  OmniModal,
  OmniModalContent,
  OmniModalHeader,
  OmniModalBody,
  OmniModalFooter,
  OmniModalCloseTrigger,
} from './ui/modal';

import { OmniAppHeaderControlButton } from './ui/appheader';

import CheatSheet from '../images/cheatsheet.svg?react';

type ModalCheatSheetProps = BoxProps;

const ModalCheatSheet: React.FC<ModalCheatSheetProps> = ({ ...rest }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box {...rest}>
      <OmniAppHeaderControlButton
        variant="contrast"
        size="sm"
        onClick={() => setIsOpen(true)}
      >
        Cheat sheet
      </OmniAppHeaderControlButton>

      <OmniModal
        open={isOpen}
        onOpenChange={(details: { open: boolean }) => setIsOpen(details.open)}
        size="xl"
        variant="default"
        closeOnInteractOutside={true}
        closeOnEscape={true}
      >
        <OmniModalContent>
          <OmniModalHeader>CheatSheet</OmniModalHeader>

          <OmniModalCloseTrigger />

          <OmniModalBody>
            <CheatSheet />
          </OmniModalBody>

          <OmniModalFooter>
            <Button variant="primary" onClick={() => setIsOpen(false)}>
              Close
            </Button>
          </OmniModalFooter>
        </OmniModalContent>
      </OmniModal>
    </Box>
  );
};

export default ModalCheatSheet;
